export const FILTER_OPEN_CLOSE = 'FILTER_OPEN_CLOSE'
